function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v66.146A66.146 66.146 0 0 1 66.146 0Zm66.146 0a66.146 66.146 0 0 1 66.146 66.146V0Zm66.146 66.146a66.146 66.146 0 0 1-66.146 66.146h66.146Zm-66.146 66.146A66.146 66.146 0 0 1 0 66.146v66.146z",
    style: {
      fill: "#000",
      fillOpacity: 0.600683,
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.146,
    cy: 66.146,
    r: 66.146,
    style: {
      fill: "#000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.734cadda4461c801dec8036a3efbbc6c.svg";
export { ForwardRef as ReactComponent };